const FooterNavigationQuery = `
query FooterNavigation($datasource: String!, $language: String!) {
  footerNavigation: item(
    path: $datasource,
    language: $language
  ) {
    ... on NavigationMenu {
      title {
        jsonValue
      }
      children(first: 100) {
        results {
          ... on SingleLink {
            link {
              jsonValue
            }
          }
        }
      }
    }
  }
}
`;

export default FooterNavigationQuery;
